export default __webpack_public_path__ + "static/media/eye-open.1658efe5.svg";